import React from 'react';

export default function AboutMe() {
  return (
    <section id='about' className='am-about-me am-section' aria-labelledby='about-me-title'>
      <div className='am-container am-about-inner'>
        <div className='am-about-visual'>
          <div className='am-about-image-wrap'>
            <img src='/assets/anna_image_newest.png' alt='Anna Maia' />
          </div>
        </div>

        <div className='am-about-copy'>
          <p className='am-about-kicker'>About me</p>
          <h2 id='about-me-title' className='am-about-title'>
            Anna Maia
          </h2>
          <div className='am-about-body'>
            <p>
              I'm Anna Maia, bringing over 10 years of expertise in Property Management. I’ve managed 500-unit
              portfolios, implementing strategies to boost efficiency and cut costs.
            </p>
            <p>
              I launched an annual home inspection program, reducing renovation expenses by 35%. With six years as a
              Housekeeping Supervisor and Manager, I implemented the ISO 9001 quality system in hotels, cutting room
              upkeep complaints by 85%.
            </p>
            <p>
              During the 2014 World Cup, I hosted 50 VIP FIFA guests, managing logistics, property preparation, and
              personalized service. My experience reflects my ability to deliver high-quality hospitality, proactive
              property management, and operational excellence, even in high-pressure environments.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
